module.exports = __webpack_public_path__ + "img/step4.033463a6.png";